import React, { useState } from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import InputError from "../../../Shared/Components/Form/InputError";
import { alertInfo } from "../../../Shared/Utils/alertMessages";

export default function FormLinksComponent({
  links,
  setLinks,
  model_type,
  model_id,
  readOnly,
}) {
  const [url, setUrl] = useState("");
  const [errors, setErrors] = useState({});
  const [editing, setEditing] = useState(false);
  const [editingUrl, setEditingUrl] = useState("");
  // Expresión regular para validar la URL
  const regexUrl = /^https?:\/\/[\w\-\.]+\.\w{2,}(\/\S*)?$/;
  const handleAddLink = (data) => {
    // Reiniciamos los errores
    setErrors({});

    // Validar que el input no esté vacío
    if (!url.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        url: { message: "El enlace es obligatorio." },
      }));
      return;
    }

    // Validar que la URL cumpla con el formato usando el regex
    if (!regexUrl.test(url)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        url: {
          message:
            "Ingrese una URL válida (debe comenzar con http:// o https://).",
        },
      }));
      return;
    }

    // Si la validación es correcta, agregar el enlace al arreglo
    setLinks([...links, { url, model_type: model_type, model_id: model_id }]);

    // Limpiar el input
    setUrl("");
  };

  const handleDeleteLink = (indexToDelete) => {
    setLinks((prevLinks) =>
      prevLinks.map((link, index) => {
        return index === indexToDelete ? { ...link, deleted: true } : link;
      })
    );
  };

  const handleCopyLinkToClipBoard = (link) => {
    navigator.clipboard.writeText(link?.url);
    // Añadir mensaje de éxito al toaster
    alertInfo("Copiado con exito");
  };
  const handleEdit = (link, i) => {
    setEditing(i);
    setEditingUrl(link.url);
  };
  const handleSave = (link, i) => {
    setLinks((prevLinks) =>
      prevLinks.map((prevLink, index) =>
        index === i ? { ...prevLink, url: editingUrl, updated: true } : prevLink
      )
    );
    setEditing(false);
  };
  return (
    <>
      <Row>
        <Col md="12">
          <Label>Enlaces</Label>
        </Col>
      </Row>
      {!readOnly && (
        <Row className="mb-3">
          <Col md="10">
            <div className="align-items-center">
              <InputGroup className="w-100">
                <InputGroupText>
                  <i className="icon-link"></i>
                </InputGroupText>
                <Input
                  name="url"
                  id="url"
                  className="form-control"
                  type="text"
                  placeholder="https://example.com"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
              </InputGroup>
              {/* Mostrar mensaje de error si existe */}
              {errors && <InputError errors={errors} name="url" />}
            </div>
          </Col>

          <Col
            md="2"
            className="d-flex align-items-center justify-content-center"
          >
            <Btn
              attrBtn={{
                color: "outline-primary",
                className: "btn",
                type: "button",
                onClick: handleAddLink,
              }}
            >
              Agregar
            </Btn>
          </Col>
        </Row>
      )}
      {links.map(function (link, i) {
        return link?.deleted !== true ? (
          <Row className="mb-1">
            <Col md="10">
              <FormGroup className="m-form__group">
                <InputGroup>
                  <InputGroupText>
                    <i className="icon-link"></i>
                  </InputGroupText>
                  <Input
                    disabled={editing !== i}
                    className="form-control"
                    type="text"
                    placeholder="https://example.com"
                    value={editing === i ? editingUrl : link.url}
                    onChange={(e) =>
                      editing === i && setEditingUrl(e.target.value)
                    }
                  />
                </InputGroup>
              </FormGroup>
            </Col>

            <Col md="2" className="d-flex align-items-center gap-3">
              {editing === i && (
                <Button
                  className="btn-no-bg"
                  type="button"
                  onClick={() => handleSave(link, i)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                >
                  <i className="icofont icofont-ui-check"></i>
                </Button>
              )}
              {editing !== i && (
                <Button
                  className="btn-no-bg"
                  type="button"
                  onClick={() => handleEdit(link, i)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                >
                  <i className="icon-pencil"></i>
                </Button>
              )}
              <Button
                className="btn-no-bg"
                type="button"
                onClick={() => handleCopyLinkToClipBoard(link)}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                <i className="icofont icofont-copy-alt"></i>
              </Button>
              {!readOnly && (
                <Button
                  className="btn-no-bg"
                  type="button"
                  onClick={() => handleDeleteLink(i)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                >
                  <i className="icon-close "></i>
                </Button>
              )}
            </Col>
          </Row>
        ) : (
          ""
        );
      })}
    </>
  );
}
